import { motion } from 'framer-motion'
import { useSlideCopy } from '@/lib/i18n'
import type { SlideProps } from '@/components/SlideWizard'
import { copy } from './Slide2Bridge.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide2Bridge(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-5xl">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease }}
        className="text-3xl sm:text-4xl text-slate-500 leading-relaxed max-w-4xl text-balance"
      >
        {c.body}
      </motion.p>
    </div>
  )
}
